import { jsx as e, jsxs as t } from "@emotion/react/jsx-runtime";
import { useTheme as k } from "@emotion/react";
import { MenuListContainer as L, MenuItemWrapper as j, Container as B } from "./MenuList.styled.js";
import { Loader as E } from "../Loader/index.js";
import { StyledSectionLabel as I } from "./MenuSections/MenuSections.styled.js";
import { Separator as g } from "../Separator/index.js";
import { Stack as v } from "../Stack/index.js";
import { MenuSections as N } from "./MenuSections/MenuSections.js";
import { MenuListVariantEnum as c } from "../../types/components/menuList.js";
const H = ({
  sections: n,
  maxHeight: a = 400,
  itemType: m = "checkbox",
  isChecked: d,
  onChange: s,
  loadMore: p,
  emptyMessage: f,
  className: h,
  selectableCardChildren: u,
  isSuggestionVisible: y = !1,
  suggestionProps: r,
  isLoading: l = !1,
  hasMore: C = !1,
  variant: o = c.SelectableCard,
  customSectionLabel: i
}) => {
  const S = k(), x = n.length === 0, b = () => l && /* @__PURE__ */ t(v, { alignItems: "center", justifyContent: "center", style: {
    paddingBottom: "4px"
  }, children: [
    /* @__PURE__ */ e(E, { color: "secondary", trailColor: "secondary" }),
    " "
  ] }), M = () => {
    if (!(!y || !r))
      return /* @__PURE__ */ t("div", { children: [
        i && /* @__PURE__ */ e(I, { variant: "sort", color: "secondary", children: i }),
        !x && o !== c.Chip && /* @__PURE__ */ e(g, { color: S.colors.default.alpha }),
        /* @__PURE__ */ e(B, { color: "primary", onClick: r.onClick, children: r.label })
      ] });
  };
  return /* @__PURE__ */ e(L, { enabled: !!(C && !l), fetchNextPage: p || (() => {
  }), maxHeight: a, className: h, children: /* @__PURE__ */ t(j, { variant: o, children: [
    /* @__PURE__ */ e(N, { sections: n, isChecked: d, onChange: s, selectableCardChildren: u, itemType: m, emptyMessage: f, variant: o }),
    b(),
    M()
  ] }) });
};
export {
  H as MenuList
};
